import { MenuItem, Stack } from "@mui/material";
import WushTextField from "../../form/WushTextField";
import { useState } from "react";
import OrderCreditCardCheckout from "./OrderCreditCardCheckout";
import CashCheckout from "./CashCheckout";
import PayLaterCheckout from "./PayLaterCheckout";

export default function OrderCheckout({ order, afterSuccess }) {
  const [ checkoutMethod, setCheckoutMethod ] = useState("credit");

  const renderCheckoutMethod = () => {
    if(checkoutMethod === 'credit') {
      return <OrderCreditCardCheckout order={order} allowPastPaymentMethods afterSuccess={afterSuccess} />;
    } else if(checkoutMethod === 'cash') {
      return <CashCheckout order={order} />;
    } else if(checkoutMethod === 'pay_later') {
      return <PayLaterCheckout order={order} afterSuccess={afterSuccess} />;
    }
  };

  return (
    <Stack>
      <Stack mb={2}>
        <WushTextField label="Payment type" formRegistration={{ onChange: (e) => setCheckoutMethod(e.target.value) }} defaultValue={"credit"} select>
          <MenuItem value="credit">Credit Card</MenuItem>
          <MenuItem value="pay_later">Pay Later</MenuItem>
          <MenuItem value="cash">Cash</MenuItem>
        </WushTextField>
      </Stack>
      <Stack>
        {renderCheckoutMethod()}
      </Stack>
    </Stack>
  );
}